"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodes = void 0;
var KeyCodes;
(function (KeyCodes) {
    KeyCodes["Backspace"] = "Backspace";
    KeyCodes["Tab"] = "Tab";
    KeyCodes["Enter"] = "Enter";
    KeyCodes["ShiftLeft"] = "Shift";
    KeyCodes["ShiftRight"] = "Shift";
    KeyCodes["ControlLeft"] = "Control";
    KeyCodes["ControlRight"] = "Control";
    KeyCodes["AltLeft"] = "Alt";
    KeyCodes["AltRight"] = "Alt";
    KeyCodes["Pause"] = "Pause";
    KeyCodes["CapsLock"] = "CapsLock";
    KeyCodes["Escape"] = "Escape";
    KeyCodes["Space"] = " ";
    KeyCodes["PageUp"] = "PageUp";
    KeyCodes["PageDown"] = "PageDown";
    KeyCodes["End"] = "End";
    KeyCodes["Home"] = "Home";
    KeyCodes["ArrowLeft"] = "ArrowLeft";
    KeyCodes["ArrowUp"] = "ArrowUp";
    KeyCodes["ArrowRight"] = "ArrowRight";
    KeyCodes["ArrowDown"] = "ArrowDown";
    KeyCodes["PrintScreen"] = "PrintScreen";
    KeyCodes["Insert"] = "Insert";
    KeyCodes["Delete"] = "Delete";
    KeyCodes["Digit0"] = "0";
    KeyCodes["Digit1"] = "1";
    KeyCodes["Digit2"] = "2";
    KeyCodes["Digit3"] = "3";
    KeyCodes["Digit4"] = "4";
    KeyCodes["Digit5"] = "5";
    KeyCodes["Digit6"] = "6";
    KeyCodes["Digit7"] = "7";
    KeyCodes["Digit8"] = "8";
    KeyCodes["Digit9"] = "9";
    KeyCodes["KeyA"] = "a";
    KeyCodes["KeyB"] = "b";
    KeyCodes["KeyC"] = "c";
    KeyCodes["KeyD"] = "d";
    KeyCodes["KeyE"] = "e";
    KeyCodes["KeyF"] = "f";
    KeyCodes["KeyG"] = "g";
    KeyCodes["KeyH"] = "h";
    KeyCodes["KeyI"] = "i";
    KeyCodes["KeyJ"] = "j";
    KeyCodes["KeyK"] = "k";
    KeyCodes["KeyL"] = "l";
    KeyCodes["KeyM"] = "m";
    KeyCodes["KeyN"] = "n";
    KeyCodes["KeyO"] = "o";
    KeyCodes["KeyP"] = "p";
    KeyCodes["KeyQ"] = "q";
    KeyCodes["KeyR"] = "r";
    KeyCodes["KeyS"] = "s";
    KeyCodes["KeyT"] = "t";
    KeyCodes["KeyU"] = "u";
    KeyCodes["KeyV"] = "v";
    KeyCodes["KeyW"] = "w";
    KeyCodes["KeyX"] = "x";
    KeyCodes["KeyY"] = "y";
    KeyCodes["KeyZ"] = "z";
    KeyCodes["MetaLeft"] = "Meta";
    KeyCodes["MetaRight"] = "Meta";
    KeyCodes["ContextMenu"] = "ContextMenu";
    KeyCodes["Numpad0"] = "0";
    KeyCodes["Numpad1"] = "1";
    KeyCodes["Numpad2"] = "2";
    KeyCodes["Numpad3"] = "3";
    KeyCodes["Numpad4"] = "4";
    KeyCodes["Numpad5"] = "5";
    KeyCodes["Numpad6"] = "6";
    KeyCodes["Numpad7"] = "7";
    KeyCodes["Numpad8"] = "8";
    KeyCodes["Numpad9"] = "9";
    KeyCodes["NumpadMultiply"] = "*";
    KeyCodes["NumpadAdd"] = "+";
    KeyCodes["NumpadSubtract"] = "-";
    KeyCodes["NumpadDecimal"] = ".";
    KeyCodes["NumpadDivide"] = "/";
    KeyCodes["F1"] = "F1";
    KeyCodes["F2"] = "F2";
    KeyCodes["F3"] = "F3";
    KeyCodes["F4"] = "F4";
    KeyCodes["F5"] = "F5";
    KeyCodes["F6"] = "F6";
    KeyCodes["F7"] = "F7";
    KeyCodes["F8"] = "F8";
    KeyCodes["F9"] = "F9";
    KeyCodes["F10"] = "F10";
    KeyCodes["F11"] = "F11";
    KeyCodes["F12"] = "F12";
    KeyCodes["NumLock"] = "NumLock";
    KeyCodes["ScrollLock"] = "ScrollLock";
    KeyCodes["AudioVolumeMute"] = "AudioVolumeMute";
    KeyCodes["AudioVolumeDown"] = "AudioVolumeDown";
    KeyCodes["AudioVolumeUp"] = "AudioVolumeUp";
    KeyCodes["LaunchMediaPlayer"] = "LaunchMediaPlayer";
    KeyCodes["LaunchApplication1"] = "LaunchApplication1";
    KeyCodes["LaunchApplication2"] = "LaunchApplication2";
    KeyCodes["Semicolon"] = ";";
    KeyCodes["Equal"] = "=";
    KeyCodes["Comma"] = ",";
    KeyCodes["Minus"] = "-";
    KeyCodes["Period"] = ".";
    KeyCodes["Slash"] = "/";
    KeyCodes["Backquote"] = "`";
    KeyCodes["BracketLeft"] = "[";
    KeyCodes["Backslash"] = "\\";
    KeyCodes["BracketRight"] = "]";
    KeyCodes["Quote"] = "'";
})(KeyCodes = exports.KeyCodes || (exports.KeyCodes = {}));
